import * as React from 'react';

import { AppRoutes } from 'constants/routes';

import SwapFormLoading from 'web/pages/swap/components/SwapForm/SwapFormLoading';

import ArrowLeft from 'assets/icons/arrows/arrow-left-16.svg';

import CircleButton from 'basics/buttons/CircleButton';
import AssetPairLoading from 'basics/loaders/AssetPairLoading/AssetPairLoading';
import ContentPlaceholder from 'basics/loaders/ContentPlaceholder/ContentPlaceholder';
import {
    Bar,
    SkeletonRow,
    SkeletonStack,
} from 'basics/loaders/ContentPlaceholder/ContentPlaceholder.styled';

import {
    Background,
    Links,
    MainBlock,
    PageHeader,
    Section,
    SectionWrap,
} from 'pages/amm/pages/PoolPage.styled';

import { ChartContent, GridLine, Identity, Plot } from './PoolPageLoading.styled';

import {
    Container as Chart,
    MobileChartPicker,
    Panels,
    Tab,
    Tabs,
    Toolbar,
} from '../PoolCharts/PoolCharts.styled';
import { Buttons, Card, Container as Sidebar, StickyContainer } from '../Sidebar/Sidebar.styled';

const PoolPageLoading = () => (
    <MainBlock>
        <ContentPlaceholder label="Loading pool">
            <Background>
                <Section>
                    <PageHeader>
                        <CircleButton to={AppRoutes.section.amm.link.index} label="Pools">
                            <ArrowLeft />
                        </CircleButton>
                    </PageHeader>
                    <Identity aria-hidden="true">
                        <AssetPairLoading large />
                        <SkeletonStack>
                            <Bar $width="22rem" $height="4.2rem" />
                            <Bar $width="17rem" />
                        </SkeletonStack>
                    </Identity>
                    <Links>
                        <Bar $width="13rem" $height="2.8rem" />
                        <Bar $width="15rem" $height="2.8rem" />
                    </Links>
                </Section>
                <Sidebar>
                    <Card>
                        <SwapFormLoading embedded />
                    </Card>
                </Sidebar>
                <StickyContainer>
                    <Card>
                        <Buttons>
                            <Bar $width="48%" $height="6.4rem" />
                            <Bar $width="48%" $height="6.4rem" />
                        </Buttons>
                    </Card>
                </StickyContainer>
                <Section>
                    <Chart $fullscreen={false} aria-hidden="true">
                        <Toolbar>
                            <Tabs>
                                {['Price', 'Volume', 'Liquidity'].map((label, i) => (
                                    <Tab as="span" key={label} $active={i === 0}>
                                        {label}
                                    </Tab>
                                ))}
                            </Tabs>
                            <MobileChartPicker>
                                <Bar $width="24rem" $height="4rem" />
                            </MobileChartPicker>
                        </Toolbar>
                        <Panels $fullscreen={false}>
                            <ChartContent>
                                <SkeletonRow>
                                    <Bar $width="14rem" $height="4rem" />
                                    <Bar $width="16rem" $height="4rem" />
                                </SkeletonRow>
                                <Plot>
                                    {Array.from({ length: 5 }, (_, i) => (
                                        <GridLine key={i}>
                                            <Bar $width="4rem" />
                                        </GridLine>
                                    ))}
                                </Plot>
                            </ChartContent>
                        </Panels>
                    </Chart>
                </Section>
                <Section>
                    <SectionWrap>
                        <SkeletonStack>
                            {Array.from({ length: 8 }, (_, i) => (
                                <SkeletonRow key={i}>
                                    <Bar $width="30%" $height="2.8rem" />
                                    <Bar $width="24%" />
                                </SkeletonRow>
                            ))}
                        </SkeletonStack>
                    </SectionWrap>
                </Section>
            </Background>
        </ContentPlaceholder>
    </MainBlock>
);

export default PoolPageLoading;
